// constants for stages
export const STAGES: {
  [key in AssignmentStage]?: { id: string; title: string; color: string }
} = {
  request: {
    id: 'request',
    title: 'New Request',
    color: 'blue'
  },
  passed: {
    id: 'passed',
    title: 'Passed',
    color: 'default'
  },
  redacted: {
    id: 'redacted',
    title: 'Redacted',
    color: 'default'
  },
  ongoing: {
    id: 'ongoing',
    title: 'Ongoing',
    color: 'orange'
  },
  rework: {
    id: 'rework',
    title: 'Rework',
    color: 'volcano'
  },
  approved: {
    id: 'approved',
    title: 'Approved',
    color: 'green'
  },
  rejected: {
    id: 'rejected',
    title: 'Rejected',
    color: 'red'
  },
  sent_to_rework: {
    id: 'sent_to_rework',
    title: 'Sent To Rework',
    color: 'green'
  },
  hold: {
    id: 'hold',
    title: 'On Hold',
    color: 'magenta'
  },
  scrapped: {
    id: 'scrapped',
    title: 'Scrapped',
    color: 'magenta'
  },
  rework_request: {
    id: 'rework_request',
    title: 'Rework Request',
    color: 'magenta'
  },
  editorial_review: {
    id: 'editorial_review',
    title: 'Editorial Review',
    color: 'cyan'
  },
  // creator_rework: {
  //   id: 'creator_rework',
  //   title: 'Creator Rework',
  //   color: 'volcano'
  // },
  client_review: {
    id: 'client_review',
    title: 'Client Review',
    color: 'cyan'
  }
}

// constant for CLIENT_STAGES
export const CLIENT_STAGES: {
  [key in AssignmentStage]?: {
    id: string
    title: string
    color: string
  }
} = {
  approved: {
    id: 'approved',
    title: 'Approved',
    color: 'green'
  },
  finished: {
    id: 'finished',
    title: 'Finished',
    color: 'cyan'
  },
  in_progress: {
    id: 'in_progress',
    title: 'In Progress',
    color: 'orange'
  },
  new: {
    id: 'new',
    title: 'New',
    color: 'blue'
  },
  ready: {
    id: 'ready',
    title: 'Ready',
    color: 'blue'
  },
  rejected: {
    id: 'rejected',
    title: 'Rejected',
    color: 'red'
  },
  hold: {
    id: 'hold',
    title: 'On Hold',
    color: 'magenta'
  },
  scrapped: {
    id: 'scrapped',
    title: 'Scrapped',
    color: 'magenta'
  },
  rework: {
    id: 'rework',
    title: 'In Progress',
    color: 'volcano'
  }
}

export const FEEDBACK_STAGE: {
  [key in FeedbackStatus]?: {
    id: string
    title: string
    color: string
  }
} = {
  feedback: {
    id: 'feedback',
    title: 'Complete',
    color: 'cyan'
  },
  rework: {
    id: 'rework',
    title: 'Rework',
    color: 'volcano'
  }
}
